import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/tailwind.css";
import "./styles/index.css";
import App from "./App";
import "./i18.js"; // Import i18n configuration

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
